import * as React from "react";
import { Mutation } from "react-apollo";
import { Form, Label, FormGroup, Input, Button } from "reactstrap";

// GraphQL
import CreateSiteMutation from "../../GraphQL/Mutations/CreateSite";
import GetCompanySites from "../../GraphQL/Queries/GetCompanySites";

// Presentation/UI
import Loader from "../../Components/Loader";

// Theme
import { Colors } from "../../Themes";

interface IProps {
  companyId: any;
  closeModal(): void;
  notification(message: string): void;
}

class AddSiteForm extends React.Component<IProps> {
  state = {
    name: "",
    region: "",
    physicalAddress: "",
    loading: false,
    error: null
  };

  // Handle change
  handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { name, value }: { name: string; value: string } = e.currentTarget;

    switch (name) {
      case "siteName":
        this.setState({ name: value });
        break;
      case "region":
        this.setState({ region: value });
        break;
      case "physicalAddress":
        this.setState({ physicalAddress: value });
        break;
      default:
        break;
    }
  };

  validateForm = (): boolean => {
    const { name } = this.state;
    // Check for undefined or empty infput fields
    if (!name) {
      this.setError("Please fill in the name of the site");
      return false;
    }
    return true;
  };

  // Error
  setError = (error: string): void => {
    this.setState(
      {
        error
      },
      () => {
        setTimeout(() => {
          this.setState({ error: null });
        }, 3000);
      }
    );
  };

  render() {
    const { name, region, physicalAddress } = this.state;
    const { companyId, closeModal, notification } = this.props;
    return (
      <Mutation<{}, {}> mutation={CreateSiteMutation}>
        {(createSite, { loading, error }) => (
          <Form
            onSubmit={e => {
              e.preventDefault();
              if (this.validateForm()) {
                this.setState({ loading: true });

                createSite({
                  variables: {
                    name,
                    region,
                    physicalAddress,
                    companyId
                  },
                  refetchQueries: [
                    {
                      query: GetCompanySites,
                      variables: { id: companyId }
                    }
                  ]
                })
                  .then(res => {
                    this.setState({ loading: false });

                    closeModal();
                    notification("Site created successfully");
                  })
                  .catch(err => {
                    this.setState({ loading: false });
                  });
              }
            }}
          >
            <FormGroup>
              <Label for="siteName">Site Name</Label>
              <Input
                type="text"
                name="siteName"
                id="siteName"
                placeholder="Site name"
                onChange={this.handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="region">Region</Label>
              <Input
                type="text"
                name="region"
                id="region"
                placeholder="Region"
                onChange={this.handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="physicalAddress">Physical Address</Label>
              <Input
                type="text"
                name="physicalAddress"
                id="physicalAddress"
                placeholder="Physical address"
                onChange={this.handleChange}
              />
            </FormGroup>
            <br />
            <FormGroup>
              <Button>
                {!this.state.loading ? <span>Save</span> : <Loader />}
              </Button>
            </FormGroup>
            {this.state.error && (
              <p style={{ textAlign: "center", color: Colors.error }}>
                {this.state.error}
              </p>
            )}
          </Form>
        )}
      </Mutation>
    );
  }
}

export default AddSiteForm;



// WEBPACK FOOTER //
// ./src/Containers/Sites/AddSiteForm.tsx